<button type="button" class="square-close" (click)="close()" [attr.aria-label]="'shared.close' | translate">
    <i-feather name="x"></i-feather>
</button>

<div class="dialog-head">
    <span class="eyebrow">{{ data.label }}</span>
    <h2 mat-dialog-title>{{ 'share.dialog.title.' + data.kind | translate }}</h2>
    <span class="meta">{{ 'share.dialog.intro.' + data.kind | translate }}</span>
</div>

<mat-dialog-content>
    @if (failed) {
        <p class="hint">{{ 'share.errors.create' | translate }}</p>
    } @else if (!link) {
        <app-loader></app-loader>
    } @else {
        <div class="link-row">
            <input
                type="text"
                readonly
                [value]="url"
                [attr.aria-label]="'share.dialog.linkLabel' | translate"
                (focus)="$any($event.target).select()" />
            <button type="button" class="copy" (click)="copy()">{{ 'share.dialog.copy' | translate }}</button>
        </div>

        <div class="channels">
            <a class="channel" [href]="whatsappUrl" target="_blank" rel="noopener">WhatsApp</a>
            <a class="channel" [href]="mailUrl">{{ 'share.dialog.mail' | translate }}</a>
            @if (canNativeShare) {
                <button type="button" class="channel" (click)="nativeShare()">{{ 'share.dialog.more' | translate }}</button>
            }
        </div>

        <ul class="facts">
            @for (fact of 'share.dialog.facts.' + data.kind | translate; track $index) {
                <li>{{ fact }}</li>
            }
        </ul>

        <p class="stats">
            {{ 'share.dialog.views' | translate: { count: link.views } }}
            @if (data.kind === 'plan') {
                · {{ 'share.dialog.takeovers' | translate: { count: link.takeovers } }}
            }
        </p>

        <button type="button" class="text-action danger" [disabled]="isBusy" (click)="revoke()">
            {{ 'share.dialog.revoke' | translate }}
        </button>
    }
</mat-dialog-content>
